import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map.component';
import { AgmCoreModule } from '@agm/core';
import { FormsModule } from '@angular/forms';
import { ModalModule } from '../modal';

@NgModule({
  declarations: [MapComponent],
  exports: [MapComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBKqs56AXovBhKrZ873VM5EQCaSes78JX4',
      libraries: ['geometry', 'places']
    })
  ]
})

export class MapModule { }
